<template>
  <transition name="fade" appear>
    <div v-if="!detectMobile() || (this.detectMobile() && this.$store.state.showHeader)" class="wrapper" ref="wrapper"
         :style="navBackgroundLinear">
      <b-navbar ref="navWrapper" class="gr-navbar-wrapper" fixed="top" :sticky="true" toggleable="lg">
        <b-navbar-brand @click="openIndex()" v-if="detectMobile()" style="cursor: pointer">
          <img src="/goldregen-logo.png" width="135px" alt="Goldschmiede Goldregen – Logo">
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse">
          <div id="burger"
               :class="{ 'active' : isBurgerActive }"
               @click.prevent="toggle">
            <button type="button" class="burger-button" title="Menu">
              <span class="burger-bar burger-bar--1"></span>
              <span class="burger-bar burger-bar--2"></span>
              <span class="burger-bar burger-bar--3"></span>
            </button>
          </div>
        </b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="font-menu gr-navbar">
            <b-nav-item v-for="navItem in navItems.items" :key="navItem.order"
                        :click="toggleDesktop(navItem.route)"
                        @click="openRoute(navItem.route.name, navItem.route)"
                        :class="detectMobile() ? 'gr-nav-item-md' : 'gr-nav-item-lg order-'+navItem.order"
            >{{ navItem.name }}
            </b-nav-item>
            {{ this.$store.showHeader }}
            <b-navbar-brand @click="openIndex()" v-if="!detectMobile()" class="gr-logo-lg order-3" style="cursor: pointer">
              <img ref="grLogoPos" src="/goldregen-logo.png"
                   :style="'width: '+ logoWidth +'px'" alt="Goldschmiede Goldregen – Logo">
            </b-navbar-brand>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    </transition>
</template>

<script>
import Vue from 'vue'

import { NavbarPlugin } from 'bootstrap-vue'

Vue.use(NavbarPlugin)

export default {
  name: 'Header',
  data () {
    return {
      navHeight: null,
      isMobile: true,
      isBurgerActive: false,
      logoPos: 0,
      logoWidth: '170',
      logoHeight: 55,
      navBarHeight: 0,
      navBarPos: 0,
      navBackgroundLinear: {},
      wrapperBg: {},
      window: {
        width: 0,
        height: 0
      },
      navItems: {
        items: [
          {
            name: 'goldschmiede',
            route: {
              name: 'goldschmiede'
            },
            order: '1'
          },
          {
            name: 'schmuckstücke',
            route: {
              name: 'schmuckstuecke'
            },
            order: '2'
          },
          {
            name: 'individuelles',
            route: {
              name: 'individuelles'
            },
            order: '4'
          },
          {
            name: 'kontakt',
            route: {
              name: 'kontakt'
            },
            order: '5'
          }
        ]
      }
    }
  },
  components: {},
  computed: {
    isLoadingImg: function () {
      return this.$store.getters['loading/isLoadingApp']
    },
    getBgBreakpoint () {
      const logoStartPoint = 8
      return (((logoStartPoint + this.logoHeight / 2)) / this.navBarHeight) * 100
    },
    getNavHeight () {
      return this.navHeight
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  mounted () {
    this.navBarHeight = this.$refs.navWrapper?.$el.clientHeight + 8
    this.logoPos = this.$refs.grLogoPos?.getBoundingClientRect().top
    this.setBackground(this.detectMobile())
    this.$store.commit('dom/SET_NAVBAR_HEIGHT', this.$refs.navWrapper.$el.clientHeight)
    this.navHeight = this.$refs.navWrapper.$el.clientHeight
  },
  updated () {
    this.navBarHeight = this.$refs.navWrapper?.$el.clientHeight + 8
    this.setBackground(this.detectMobile())
  },
  methods: {
    openIndex () {
      if (this.$route.name === 'index') {
        this.$parent.$children[1].$refs.fullpage.api.moveTo(1)
      } else {
        this.$routePush({ path: '/#willkommen' }, 500)
      }
    },
    openRoute (name, route) {
      if (this.$route.name === name) {
        console.log('skip route because is already current route.')
      } else {
        if (name === 'kontakt') {
          if (this.$route.name === 'index') {
            this.$parent.$children[1].$refs.fullpage.api.moveTo(5)
          } else {
            this.$routePush({
              name: 'index',
              hash: '#kontakt'
            })
          }
        } else {
          this.$routePush(route)
        }
      }
    },
    toggle () {
      this.isBurgerActive = !this.isBurgerActive
    },
    toggleDesktop (name) {
      this.isBurgerActive = this.isBurgerActive ? !this.isBurgerActive : this.isBurgerActive
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
      this.logoPos = this.logoPos ? this.logoPos : this.$refs.grLogoPos?.getBoundingClientRect().top
    },
    detectMobile () {
      return this.window.width < 992
    },
    setBackground (mobile) {
      if (mobile) {
        this.$delete(this.navBackgroundLinear, 'backgroundImage')
        this.$set(this.navBackgroundLinear, 'background', '#D3E9E2')
      } else {
        this.$delete(this.navBackgroundLinear, 'background')
        this.$set(this.navBackgroundLinear, 'backgroundImage', `linear-gradient(0deg, rgba(255,0,0,0) ${this.getBgBreakpoint}%, #D3E9E2 ${this.getBgBreakpoint}%)`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .font-menu {
    letter-spacing: 0.06em;
    font-family: $font-content;
  }

  .wrapper {
    z-index: 900 !important;
    max-width: 100vw;
  }

  .gr-navbar-wrapper {
    min-height: 70px;
    padding: 0 1rem;
  }

  .gr-navbar {
    width: 100%;
    justify-content: space-evenly;
    min-height: 80px;
  }

  .gr-nav-item-md {
    padding: 15px;
  }

  .gr-nav-item-md a,
  .gr-nav-item-lg a {
    transition: opacity .25s ease;
  }

  .gr-nav-item-md a:hover,
  .gr-nav-item-lg a:hover {
    opacity: 0.6;
  }

  .gr-nav-item-lg {
    align-self: flex-start;
    flex-basis: 100%
  }

  .navbar-toggler {
    border: none;
    outline: none;
    align-self: flex-start;
    margin: 18px 6px 0 0;
    padding: 0;
  }

  .hidden {
    visibility: hidden;
  }

  button {
    cursor: pointer;
  }

  /* remove blue outline */
  button:focus {
    outline: 0;
  }

  .burger-button {
    position: relative;
    height: 30px;
    width: 32px;
    display: block;
    z-index: 900;
    border: 0;
    border-radius: 0;
    background-color: transparent;
    pointer-events: all;
    transition: transform .6s cubic-bezier(.165, .84, .44, 1);
  }

  .burger-bar {
    background-color: $color-gr-gray;
    position: absolute;
    top: 50%;
    right: 6px;
    left: 6px;
    height: 2px;
    width: auto;
    margin-top: -1px;
    transition: transform .6s cubic-bezier(.165, .84, .44, 1), opacity .3s cubic-bezier(.165, .84, .44, 1), background-color .6s cubic-bezier(.165, .84, .44, 1);
  }

  .burger-bar--1 {
    -webkit-transform: translateY(-6px);
    transform: translateY(-6px);
  }

  .burger-bar--2 {
    transform-origin: 100% 50%;
    transform: scaleX(.8);
  }

  .burger-button:hover .burger-bar--2 {
    transform: scaleX(1);
  }

  .no-touchevents .burger-bar--2:hover {
    transform: scaleX(1);
  }

  .burger-bar--3 {
    transform: translateY(6px);
  }

  #burger.active .burger-button {
    transform: rotate(-180deg);
  }

  #burger.active .burger-bar {
    background-color: $color-gr-gray;
  }

  #burger.active .burger-bar--1 {
    transform: rotate(45deg)
  }

  #burger.active .burger-bar--2 {
    opacity: 0;
  }

  #burger.active .burger-bar--3 {
    transform: rotate(-45deg)
  }

  .navbar-brand {
    align-self: flex-start;
    margin: 13px 0 0 6px;
    padding: 0;
  }

  .burger-icon {
  }

  li {
    text-align: center;
  }

  @media (min-width: $window-lg) {
    .navbar-brand {
      margin: 10px 0 0 0;
    }

    .gr-logo-lg {
      align-self: flex-end;
    }

    .font-menu {
      letter-spacing: 0.04em;
      font-weight: 500;
    }
    .gr-navbar-wrapper {
      padding: 0.5rem 1rem !important;
    }
  }
</style>
